'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { DomainConfigSection } from './DomainConfigSection';
import { ProductsManager, ProductItem, CategoryOption } from './ProductsManager';
import { CategoriesManager, CategoryData } from './CategoriesManager';

interface AdminDashboardClientProps {
  products: ProductItem[];
  categories: (CategoryData & CategoryOption)[];
  publicIp: string;
  localIp: string;
}

export function AdminDashboardClient({
  products,
  categories,
  publicIp,
  localIp,
}: AdminDashboardClientProps): React.JSX.Element {
  const [activeTab, setActiveTab] = useState<'dns' | 'products' | 'categories'>('dns');

  return (
    <div className="w-full px-4 sm:px-8 lg:px-12 py-10">
      {/* Cabecera del Panel */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8 border-b border-[#2A2545]/60 pb-6">
        <div>
          <div className="inline-flex items-center space-x-2 text-xs font-mono text-emerald-400 uppercase tracking-widest mb-1">
            <span>🛡️ Panel de Control Oficial</span>
          </div>
          <h1 className="text-2xl sm:text-4xl font-black text-white uppercase tracking-tight">
            Administración Planeta Kaio
          </h1>
        </div>
        <Link
          href="/"
          className="px-4 py-2 rounded-xl bg-slate-800 hover:bg-slate-700 text-xs font-mono text-emerald-400 transition-colors"
        >
          ← Ver Tienda en Vivo
        </Link>
      </div>

      {/* Tabs de Navegación */}
      <div className="flex items-center space-x-3 mb-8 border-b border-[#2A2545]/40 pb-3 overflow-x-auto">
        <button
          onClick={() => setActiveTab('dns')}
          className={`px-4 py-2 rounded-xl font-mono text-xs font-bold transition-all cursor-pointer whitespace-nowrap ${
            activeTab === 'dns'
              ? 'bg-amber-400 text-black shadow-[0_0_15px_rgba(255,179,0,0.4)]'
              : 'bg-[#12111F] text-slate-400 hover:text-white border border-[#2A2545]'
          }`}
        >
          🌐 Dominio & DNS (DonWeb)
        </button>

        <button
          onClick={() => setActiveTab('products')}
          className={`px-4 py-2 rounded-xl font-mono text-xs font-bold transition-all cursor-pointer whitespace-nowrap ${
            activeTab === 'products'
              ? 'bg-amber-400 text-black shadow-[0_0_15px_rgba(255,179,0,0.4)]'
              : 'bg-[#12111F] text-slate-400 hover:text-white border border-[#2A2545]'
          }`}
        >
          📦 Gestión de Productos ({products.length})
        </button>

        <button
          onClick={() => setActiveTab('categories')}
          className={`px-4 py-2 rounded-xl font-mono text-xs font-bold transition-all cursor-pointer whitespace-nowrap ${
            activeTab === 'categories'
              ? 'bg-amber-400 text-black shadow-[0_0_15px_rgba(255,179,0,0.4)]'
              : 'bg-[#12111F] text-slate-400 hover:text-white border border-[#2A2545]'
          }`}
        >
          📂 Categorías & 7 Esferas ({categories.length})
        </button>
      </div>

      {/* Contenido según Tab */}
      <div>
        {activeTab === 'dns' && (
          <DomainConfigSection publicIp={publicIp} localIp={localIp} />
        )}

        {activeTab === 'products' && (
          <ProductsManager products={products} categories={categories} />
        )}

        {activeTab === 'categories' && (
          <CategoriesManager categories={categories} />
        )}
      </div>
    </div>
  );
}
